module.exports = __webpack_public_path__ + "static/media/graph.5ebef0e4.svg";